import React, { useEffect, useState } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { connect } from "react-redux";
import { actions } from "../../../../redux/actions/alert";
import { SiteService } from "../../../../services/site.service";
import { Chip } from "@material-ui/core";
import styles from "../../../../styles/global-styles";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#1C2668",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#F9F9F9", //theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
  lowExistence: styles.lowExistence,
  mediumExistence: styles.mediumExistence,
  highExistence: styles.highExistence,
});

const ComparativeTable = ({ addAlert, detailAlert, filterProductArray }) => {
  const classes = useStyles();

  const [siteArray, setSiteArray] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await SiteService.getSites();
        setSiteArray(data);
      } catch (err) {
        console.log(err);
        addAlert({ showAlert: true });
        detailAlert({
          severity: "error",
          message: err.msgs,
        });
      }
    })();
  }, []);

  const getProductsAvailableBySite = () => {
    if (siteArray.length) {
      const result = filterProducts();
      return result.map((item, id) => (
        <StyledTableCell key={id} align="center" component="th" scope="row">
          <Chip
            label={item.quantity}
            className={
              item.quantity <= 3
                ? classes.lowExistence
                : item.quantity <= 7
                ? classes.mediumExistence
                : classes.highExistence
            }
          />
        </StyledTableCell>
      ));
    }
  };

  const filterProducts = () => {
    const filterProducts = [];
    siteArray.forEach((site) => {
      let notEqualcounter = 0;
      for (let i = 0; i < filterProductArray.length; i++) {
        const productSiteId =
          filterProductArray[i].movile?.siteId ||
          filterProductArray[i].accesory?.siteId ||
          filterProductArray[i].chip?.siteId ||
          filterProductArray[i].cash_card?.siteId;

        if (site.id === productSiteId) {
          /*
          console.log(
            `siteID ${site.id}  equal to productSiteID ${
              filterProductArray[i].movile?.siteId ||
              filterProductArray[i].accesory?.siteId ||
              filterProductArray[i].chip?.siteId ||
              filterProductArray[i].cash_card?.siteId
            }`
          );
          */
          filterProducts.push(filterProductArray[i]);
          break;
        } else {
          notEqualcounter++;
        }
      }
      if (notEqualcounter === filterProductArray.length) {
        filterProducts.push({ quantity: 0 });
      }
    });
    return filterProducts;
  };

  const getProductName = () => {
    const brand =
      filterProductArray[0].movile?.brand ||
      filterProductArray[0].accesory?.brand ||
      filterProductArray[0].chip?.chip_catalogue?.name ||
      filterProductArray[0].cash_card?.card_catalogue?.name ||
      "";
    const model =
      filterProductArray[0].movile?.model ||
      filterProductArray[0].accesory?.model ||
      filterProductArray[0].cash_card?.card_catalogue?.amount ||
      "";
    return `${brand} ${model}`;
  };

  return (
    <TableContainer style={{ marginTop: 30 }} component={Paper}>
      <Table className={classes.table} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell align="left">Producto</StyledTableCell>
            {siteArray.map((row, i) => (
              <StyledTableCell key={i} align="center">
                {row.name}
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <StyledTableRow>
            <StyledTableCell align="left" component="th" scope="row">
              {getProductName()}
            </StyledTableCell>
            {getProductsAvailableBySite()}
          </StyledTableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(null, dispatch)(ComparativeTable);
